// Use the visitor's local calendar. A Saturday visit points to the following
// Saturday, so the displayed start date is always in the future.
export const getNextSaturday = (today = new Date()) => {
  const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const daysAhead = (6 - date.getDay() + 7) % 7 || 7;
  date.setDate(date.getDate() + daysAhead);
  return date;
};

export const formatCohortDate = (date, locale) => new Intl.DateTimeFormat(
  locale === 'en' ? 'en-GB' : 'fr-FR',
  { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' },
).format(date);
